import React from 'react';

export default function Card({ children }) {
  return (
    <div className='tw-group/card tw-relative tw-h-80 tw-rounded-lg tw-border-1 tw-border-solid tw-border-grey-100 tw-bg-white'>
      {children}
    </div>
  );
}
